import React from "react";
import AliancesBanner from "../../../assets/images/AliancesBanner.jpg";
import MiddlexesLondon from "../../../assets/images/MiddlexesLondon.jpg";
import Lincoln from "../../../assets/images/Lincoln.jpg";
import Boldon from "../../../assets/images/Boldon.jpg";
import Ncc from "../../../assets/images/Ncc.jpg";
import LRN from "../../../assets/images/LRN.jpg";
import Canada from "../../../assets/images/Canada.jpg";
import styles from "./AliancessSection.module.scss";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";

const items: string[] = [
  "Middlesex University, London",
  "Lincoln University College, Malaysia",
  "University of Bolton, Ras Al-Khaimah",
  "NCC Education, UK",
  "Learning Resource Network (LRN)",
  "Centre for Entertainment Arts, Canada",
];

interface DataItemWorkForce {
  src: string;
  text: string;
  title: string;
}

const workforce: DataItemWorkForce[] = [
  {
    src: MiddlexesLondon,
    text: "As part of the alliance between Aptech and Middlesex University, students who complete their Advanced Diploma at Aptech or Arena Multimedia can directly enter the final year of a B.Sc. (Hons.) or BA (Hons.) program through the credit transfer facility.",
    title: "Middlesex University, London",
  },
  {
    src: Lincoln,
    text: "Aptech has partnered with Lincoln University College, Malaysia, to offer an international degree to students while they pursue a course by staying in their home country. ",
    title: "Lincoln University College, Malaysia ",
  },
  {
    src: Boldon,
    text: "A progressive collaboration between Aptech and University of Bolton, Ras Al-Khaimah (UOBRAK) aims to empower Aptech students with an International Degree at the university campus in UAE. The idea of this alliance is to offer the students study abroad facility and an international degree which gives them competitive advantage at an affordable cost.",
    title: "University of Bolton, Ras Al-Khaimah ",
  },
  {
    src: Ncc,
    text: "Aptech, in partnership with NCC Education offers deserving students the opportunity to obtain a Level 5 Diploma in Computing (L5 DC), driving them ahead in their careers. This alliance equips students with the essential skills to thrive in a competitive global workplace. ",
    title: "NCC Education, UK",
  },
  {
    src: LRN,
    text: "Aptech has collaborated with LRN enabling students to get an international qualification at an affordable cost. The major objective of this collaboration is to empower Aptech/Arena/MAAC students with L4 Diploma in I.T. and L5 Advanced Diploma in I.T., who has successfully completed either Advanced Diploma/ certificate –Two-year program. ",
    title: "Learning Resource Network (LRN) ",
  },
  {
    src: Canada,
    text: "As a part of this strategic alliance, MAAC and Arena students can apply to Centre for Entertainment Arts for a 2-year Advanced Diploma in 3D Animation, Visual Effects (VFX) or Game Design. As international students at this institute, they will be eligible to get up to 3-years post-graduation work permit (PGWP) in Canada.",
    title: "Centre for Entertainment Arts, Canada ",
  },
];

const AliancessSection: React.FC = () => {
  
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Alliances", link: "" },
  ];

  return (
    <div id="AliancessSection" className={styles.aliancessSection}>
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
        <Banner />
        <AlianceListView  />
        <UniversityCardSection />
      </div>
    </div>
  );
};

const Banner = () => {
  return (
    <div className="section">
      <div className="row position-relative mt-4">
      <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
        <div className={styles.aliancessBannerSection}>
          <p className="heading">alliances</p>
          <p className="para">
            Aptech has partnered with numerous universities & institutions in
            India and abroad to enable high progression with pathway programs
            and create career opportunities.
          </p>
          <p className="para">
            The partnerships enable students to get access to industry-aligned
            programs, advanced learning resources, and collaborative projects
            that prepare them to excel in their chosen fields.
          </p>
        </div>
      </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <img src={AliancesBanner} alt="AllianceImage" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};



const AlianceListView = () => {
  const scrollToCard = (index: number) => {
    const element = document.getElementById(`university-${index}`);
    if (element) {
      const offset = -100; // Adjust this value to ensure full visibility
      const yPosition =
        element.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({
        top: yPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="section">
      <div className="row">
        <div className="col-12">
          <p
            className={`para text-center mt-2 mb-2 ${styles.aliancessListView}`}
          >
            Aptech has tied up with
          </p>
          {items.map((item, index) => (
            <div key={index} className={styles.listDiv}>
            <p
              className={`subHeading ${styles.universitiesList}`}
              onClick={() => scrollToCard(index)}
              style={{ cursor: "pointer" }} // Make the list item clickable
            >
              {item}{" "}
            </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};



const UniversityCardSection = () => {
  return (
    <div className="section">
      <div className="row g-0">
        <div className="col-12">
          {workforce.map((item, index) => (
            <div
              id={`university-${index}`}
              key={index}
              className={`${"row mb-4 g-0"} ${styles.universitiesWithDetails}`}
            >
              <div
                className={`col-lg-8 col-md-8 col-sm-12 ${styles.detailsText}`}
              >
                <p className="heading">{item.title}</p>
                <p className="para mb-0">{item.text}</p>
              </div>
              <div
                className={`${"col-lg-4 col-md-4 col-sm-12 d-flex"} ${
                  styles.imgBox
                }`}
              >
                <img src={item.src} className="img-fluid" alt="universityImg" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


export default AliancessSection;
